import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=b6a442e2&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=b6a442e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a442e2",
  null
  
)

export default component.exports